import css from './FragmentInfoFooterStep3.module.css';
import React from 'react';
import { FormatNumber } from '@shared/Helpers/FormatValue/FormatNumber/FormatNumber';

interface Props {
    grandTotal: number;
    selectedTotal: number;
}

export const FragmentInfoFooterStep3: React.FC<Props> = ({
    grandTotal,
    selectedTotal,
}) => {
    return (
        <div className={css.fragmentFooter}>
            <div className={css.fragmentFooterTotal}>
                <div className={css.priceDescription}>
                    Fragment grand total:
                </div>
                <div className={css.price}>
                    {' '}
                    R {FormatNumber(grandTotal, '0.00')}
                </div>
            </div>
            <div className={css.fragmentFooterTotal}>
                <div className={css.priceDescription}>Total selected:</div>
                <div className={css.price}>
                    R {FormatNumber(selectedTotal, '0.00')}
                </div>
            </div>
        </div>
    );
};
